import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import { StyleSheet, Text } from 'react-native'

interface AuthFieldErrorMessageProps {
    children: string
}

const AuthFieldErrorMessage: FC<AuthFieldErrorMessageProps> = ({ children }) => {
    return <Text style={styles.errorMessage}>{children}</Text>
}

const styles = StyleSheet.create({
    errorMessage: {
        color: ColorEnum.RED_600,
        fontSize: 14,
        lineHeight: 18,
    },
})

export default AuthFieldErrorMessage
